import React, { Component } from 'react'
import forEach from 'lodash/forEach'
import {Link} from 'react-router-dom'

class SegmentNav extends Component {
	getCurrentSteps() {
		let currentSteps = {};

		const steps = {
			'create': () => true,
			'confirm': () => false
		};

		forEach(steps, (check, step) => {
			currentSteps[step] = true;
			if (step === this.props.match.params.step) return false;
			/*
			if (currentSegment && currentSegment.id && true) return check(currentSegment);
			// otherwise, use the current step to check progress
			else if (step === this.props.match.params.step) return false;*/
		});

		return currentSteps;
	}
/*
	getCurrentBreadcrumb(currentSteps) {
		return currentSteps ? Object.keys(currentSteps).indexOf(this.props.location.queryStep) : 0;
	}
*/
	render() {
		const currentSteps = this.getCurrentSteps()
		return (
			<div className="steps-basic wizard clearfix color-grey-400">
				<div className="steps clearfix">
					<ul role="tablist">
						<li role="tab" className={ (!currentSteps.confirm) || (currentSteps.confirm === false) ? "first current" : "first"} aria-selected="true" aria-disabled="false">
							<Link id="steps-uid-0-t-0" to="/segment/create" aria-controls="step-uid-0-p-0">
								<span className="current-info audible">current step: </span>
								<span className="number">1</span>
								Select Attributes
							</Link>
						</li>
						<li role="tab" className={currentSteps.confirm === true ? "current" : "disabled"} aria-disabled="True">
							<Link id="steps-uid-0-t-1" to="/segment/confirm" aria-controls="step-uid-0-p-1">
								<span className="number">2</span>
								Verify and Save
							</Link>
						</li>
					</ul>
				</div>
			</div>
		)
	}
}

export default SegmentNav


// WEBPACK FOOTER //
// ./src/components/framework/SegmentNav.js